import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import ConfirmForm from "./components/ConfirmForm";
import SyncMessage from "../../components/SyncMessage";

class AdkBids extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            bidToUpdate: null,
            sortParam: null,
            sortOrder: 1,
            syncData: null,
            bids: []
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleConfirmFormHide = this.handleConfirmFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    componentDidMount() {
        this.loadBids();
    }

    componentWillUpdate(nextProps, nextState) {
        const { bids, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(bids, sortParam, sortOrder);

            this.setState({ bids });
        }
    }

    sortReport(bids, sortParam, sortOrder) {
        bids.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadBids() {
        this.setState({ isLoading: true });

        API.AdkBids.get().then(bids => this.setState({ bids, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, bidToUpdate: null });
    }

    handleConfirmFormHide() {
        this.setState({ bidToRemove: null });
    }

    handleFormSubmit(bid) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            bidToUpdate: null
        });

        API.AdkBids.save(bid).then(() => this.loadBids());
    }

    handleUpdateBtnClick(bid) {
        this.setState({ isShowForm: true,  bidToUpdate: bid });
    }

    handleRemoveBtnClick(id) {
        this.setState({ bidToRemove: id });
    }

    handleRemove() {
        const { bidToRemove } = this.state;

        this.setState({ isLoading: true, bidToRemove: null });

        API.AdkBids.remove(bidToRemove).then(() => this.loadBids());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync([ 'adk-EU', 'adk-US', 'adk-SG' ], 'bids')
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });

                setTimeout(() => this.setState({ syncData: null }), 10000);
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
                setTimeout(() => this.setState({ syncData: null }), 10000);
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }



    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                bid={this.state.bidToUpdate}
                types={this.state.types}
            />;
        }
    }

    getConfirmForm() {
        if(this.state.bidToRemove) {
            return <ConfirmForm
                onFormHide={this.handleConfirmFormHide}
                onConfirm={this.handleRemove}
                country={this.state.bidToRemove}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="ADK Bids"/>
                <Row>
                    <Col lg={12}>
                        <div className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </div>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />
                {this.getConfirmForm()}
                {this.getForm()}

                <Table bids={this.state.bids} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default AdkBids;


// WEBPACK FOOTER //
// ./src/scenes/AdkBids/index.js